function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';

var FullscreenItemPreload = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenItemPreload, _React$Component);

  function FullscreenItemPreload() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenItemPreload.prototype;

  _proto.render = function render() {
    var _this = this;

    if (this.props.loaded && this.props.item.type === 'video') {
      return null;
    }

    var item = this.props.item;
    var idx = this.props.item.idx;
    var size = {
      width: this.props.width ? this.props.width : this.props.item.width + 'px',
      height: this.props.height ? this.props.height : this.props.item.height + 'px'
    };

    var innerStyle = _objectSpread({
      backgroundColor: item.bgColor,
      objectFit: 'contain',
      zIndex: -2,
      position: 'absolute'
    }, size);

    var getResizedPreloadImage = function getResizedPreloadImage() {
      return item.isImage || item.isVideo ? /*#__PURE__*/React.createElement("img", {
        className: 'fullscreen-item fullscreen-item-preload',
        src: item.createUrl('resized', 'img'),
        style: _objectSpread(_objectSpread({}, innerStyle), {}, {
          zIndex: -1
        }),
        key: 'resized-preload',
        alt: 'resized-preload'
      }) : null;
    };

    var getBluryPreloadImage = function getBluryPreloadImage() {
      var preloads = [];

      if ((item.isImage || item.isVideo) && !item.isTransparent) {
        preloads.push( /*#__PURE__*/React.createElement("img", {
          className: 'fullscreen-item fullscreen-item-preload',
          src: item.preload_img,
          style: innerStyle,
          key: 'blury-preload',
          alt: 'blury-preload'
        }));

        if (!_this.props.loaded) {
          preloads.push( /*#__PURE__*/React.createElement("div", {
            className: "pro-circle-preloader"
          }));
        }

        return preloads;
      }

      return getEmptyPreload();
    };

    var getEmptyPreload = function getEmptyPreload() {
      return /*#__PURE__*/React.createElement("div", {
        className: 'fullscreen-item fullscreen-item-preload',
        style: innerStyle,
        key: 'preload'
      });
    };

    return /*#__PURE__*/React.createElement("div", {
      className: 'fullscreen-preload fullscreen-preload-' + idx,
      key: 'preload_container'
    }, getBluryPreloadImage(), getResizedPreloadImage());
  };

  return FullscreenItemPreload;
}(React.Component);

export default FullscreenItemPreload;